import React from "react";
import { Link } from "react-router-dom";
import { Github, Twitter, Linkedin } from "lucide-react";
import { cn } from "../lib/utils";

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gray-700/40">
      <div className="container px-4 md:px-6 py-12 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="flex flex-col">
            <div className="flex items-center space-x-2 mb-4">
              <div className="relative w-8 h-8 overflow-hidden rounded-md">
                <img 
                  src="/logo-light.png" 
                  alt="Nuclius AI" 
                  className="w-full h-full object-contain" 
                />
              </div>
              <span className="font-semibold text-xl text-white">Nuclius</span>
            </div>
            <p className="text-sm text-gray-300 mt-2 mb-4">
              Revolutionizing video editing with artificial intelligence
            </p>
            <div className="flex space-x-4 mt-auto">
              <a href="https://github.com" className="text-gray-300 hover:text-orange-500" aria-label="GitHub">
                <Github className="h-5 w-5" />
              </a>
              <a href="https://twitter.com" className="text-gray-300 hover:text-orange-500" aria-label="Twitter">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com" className="text-gray-300 hover:text-orange-500" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-medium text-sm text-white mb-3">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/features" className="text-gray-300 hover:text-orange-500">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 hover:text-orange-500">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/integrations" className="text-gray-300 hover:text-orange-500">
                  Integrations
                </Link>
              </li>
              <li>
                <Link to="/changelog" className="text-gray-300 hover:text-orange-500">
                  Changelog
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-medium text-sm text-white mb-3">Resources</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/docs" className="text-gray-300 hover:text-orange-500">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/api" className="text-gray-300 hover:text-orange-500">
                  API
                </Link>
              </li>
              <li>
                <Link to="/guides" className="text-gray-300 hover:text-orange-500">
                  Guides
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-300 hover:text-orange-500">
                  Support
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-medium text-sm text-white mb-3">Company</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-orange-500">
                  About
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-orange-500">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-300 hover:text-orange-500">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-orange-500">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center border-t border-gray-700/40 mt-10 pt-6 text-sm text-gray-300">
          <p>© {new Date().getFullYear()} Nuclius. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-orange-500">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-orange-500">
              Terms
            </Link>
            <Link to="/cookies" className="hover:text-orange-500">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 